module.exports = __webpack_public_path__ + "assets/e7ce574f51b4d1de75cc8601666d2675.mp3";